import React from 'react';

import './style.sass';

const ContentCaseHeader = ({ listTitle }) => {
    return (
        <>
            {listTitle.map((item, index) => (
                <div className="content-case__header-inner" key={index}>
                    {item.subtitle ? (
                        <div className="content-case__header">
                            <h1
                                className="content-case__title"
                                dangerouslySetInnerHTML={{ __html: item.title }}
                            />
                            <div
                                className="content-case__subtitle"
                                dangerouslySetInnerHTML={{ __html: item.subtitle }}
                            />
                        </div>
                    ) : (
                        <div className="content-case__header">
                            <h1
                                className="content-case__title"
                                dangerouslySetInnerHTML={{ __html: item.title }}
                            />
                        </div>
                    )}
                </div>
            ))}
        </>
    );
};

export default ContentCaseHeader;
